import React, { useCallback, useEffect, useState } from "react";
import digiApi from "../../Api/digiApi";
import { Box, Chip, Grid } from "@mui/material";
import { lightBlue } from "@mui/material/node/colors";
import { DataGrid } from "@mui/x-data-grid";
import { CircularProgress } from "@mui/material";
import { Button } from "@mui/material";
import moment from "moment";
import { Card } from "@mui/material";
import { CardHeader } from "@mui/material";
import { Typography } from "@mui/material";
import { CardContent } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { customerAccounts, userData } from "../../Redux/userSlice";
import PageLoader from "../../Components/PageLoader";
import TableComponent from "../../Components/TableComponent";
import Page from "../../Components/Page";
import { getFullName, getKycChip } from "../../utils/helpers";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AlertComponent from "../../Components/AlertComponent";
import UseServerTable from "../../Hooks/UseServerTable";
import ErrorDisplay from "../../Components/ErrorDisplay";
import { AllInbox } from "@mui/icons-material";

const Customers = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const customers = useSelector((state) => state.usersData.customerAccounts);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const { gridProps, error, refresh } = UseServerTable({
    baseUrl: "/entity?type=customer",
    onSuccess: (data) => {
      dispatch(customerAccounts(data.Data));
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      renderCell: (row) => (
        <Button
          variant="outlined"
          size="small"
          // style={{ fontWeight: "normal" }}
          startIcon={<VisibilityIcon />}
          onClick={() => {
            navigate("/dashboard/users/user-profile", {
              state: { user: row.row },
            });
            dispatch(userData(row.row));
          }}
        >
          Profile
        </Button>
      ),
      minWidth: 150,
      flex: 1,
    },
    { field: "id", headerName: "Entity Id", minWidth: 150, flex: 1 },
    {
      field: "document_number",
      headerName: "Identification No",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "fullname",
      headerName: "Full Name",
      valueGetter: (params) => {
        // getFullName(params.row)
        const nameParts = [
          params.row?.first_name,
          params.row?.other_names,
          params.row?.surname,
        ];
        return nameParts
          .filter((name) => name && name !== "undefined")
          .join(" ");
      },
      minWidth: 200,
      flex: 1,
    },
    { field: "msisdn", headerName: "Phone No", minWidth: 150, flex: 1 },
    // { field: "role", s: "Role", minWidth: 100, flex: 1 },
    {
      field: "active_status",
      headerName: "Active Status",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => getKycChip(params.value),
    },
    {
      field: "kyc_status",
      headerName: "KYC Status",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => getKycChip(params.value),
    },
    {
      field: "start_date",
      headerName: "Start date",
      minWidth: 200,
      flex: 1,
      valueFormatter: (params) =>
        moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    },
  ];

  return (
    <Page
      title={
        <Typography variant="h4" fontWeight="bold">
          Customers
        </Typography>
      }
    >
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <Card
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          height: "100%",
        }}
      >
        <CardContent
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            p: 2,
            overflow: "hidden",
            "& .MuiDataGrid-root": {
              // border: "none",
            },
          }}
        >
          {gridProps.loading ? (
            <PageLoader />
          ) : customers && customers.length > 0 ? (
            <Box>
              <TableComponent
                columns={columns}
                data={customers}
                sortModel={[
                  {
                    field: "start_date",
                    sort: "desc",
                  },
                ]}
                {...gridProps}
              />
            </Box>
          ) : (
            <ErrorDisplay
              message="No Customers Found!"
              // details="Plesase apply for a loan."
              icon={
                <AllInbox color="secondary" sx={{ mx: "auto", fontSize: 80 }} />
              }
            />
          )}
        </CardContent>
      </Card>
      {/* </Box> */}
    </Page>
  );
};

export default Customers;
